
import { Bar, mixins } from 'vue-chartjs';
import Vue, { PropType } from 'vue';
import { ChartData, ChartOptions } from 'chart.js';

export default Vue.extend({
	extends: Bar,

	mixins: [mixins.reactiveProp],

	props: {
		chartData: {
			type: Object as PropType<ChartData>,
			default: null,
		},
		options: {
			type: Object as PropType<ChartOptions>,
			default: null,
		},
	},

	mounted() {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(this as any).renderChart(this.chartData, this.options);
	},
});
